import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import UserUtils from '@/utils/user';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UseCheckAuth from '@/admin/hooks/UseCheckAuth';

const RouterError = () => {
  const navigate = useNavigate();
  const { user, appLoaded } = useAppSelector(authSelector);
  UseCheckAuth();

  useEffect(() => {
    let isActive = true;

    const timer = setTimeout(() => {
      if (!isActive || !appLoaded) {
        return;
      }

      const isAdmin = UserUtils.isAdmin(user);

      if (!isAdmin) {
        return;
      }

      navigate('/', { replace: true });
    }, 1000);

    return () => {
      isActive = false;
      clearTimeout(timer);
    };
  }, [user, appLoaded]);

  return <></>;
};

export default RouterError;
